<span
  *ngrxLet="(relevantArticlesCount() | number) + ' / ' + (articlesCount() | number) as condtionArticlesCount"
  [title]="condtionArticlesCount"
  >{{ condtionArticlesCount }}</span
>
